import { icons, RawLink } from '@portal/components'
import React from 'react'

const { InformationCircle, Check, ArrowUpRight } = icons

export const TIPS = ["Strings use 'single' quotes, e.g. WHERE color = 'blue'"]

export default function EmptyResultTips() {
  return (
    <div className="flex flex-col gap-y-3 rounded-md border border-border-normal bg-background-surface-secondary p-4">
      <div className="flex items-center gap-x-2 text-foreground-normal">
        <InformationCircle className="h-4 w-4 text-foreground-normal" />
        <h3 className="text-base font-medium">
          Not what you expected? These tips might help.
        </h3>
      </div>

      {TIPS.map((tip) => (
        <div
          className="flex items-center gap-x-2 text-foreground-normal"
          key={tip}
          data-testid="emptyResultTip"
        >
          <Check className="h-4 w-4 text-foreground-subtle" />
          <p className="font-plex-mono text-base">{tip}</p>
        </div>
      ))}

      <p className="inline-flex items-end">
        <span>Read more about DQL rules and syntax</span>&nbsp;
        <RawLink
          href="https://docs.ditto.live/dql"
          className="underline"
          isBlank
        >
          in the docs
        </RawLink>
        &nbsp;
        <ArrowUpRight className="h-4 w-4 text-foreground-subtle" />
      </p>
    </div>
  )
}
